import React from "react";
import { Navigate, Outlet } from "react-router";
import { ROUTES_CONSTANTS } from "../constants";
import { getFromStorage } from "../utils";
import { useAuth } from "../context";
import { Loader } from "../components";

const CompanyLayout = () => {
  const token = getFromStorage("accessToken");
  const { currentUser, isLoading } = useAuth();

  if (!token) {
    return <Navigate to={ROUTES_CONSTANTS.LOGIN} replace />;
  }

  if (isLoading || !currentUser) {
    return <Loader />;
  }

  if (currentUser.role_id === 0) {
    return <Navigate to={ROUTES_CONSTANTS.COMPANY_MANAGEMENT} replace />;
  }

  return (
    <div className="p-8 min-h-screen">
      <Outlet />
    </div>
  );
};

export default CompanyLayout;
